import { render, staticRenderFns } from "./_siteCreditsTotal.vue?vue&type=template&id=67b04178"
import script from "./_siteCreditsTotal.vue?vue&type=script&lang=js"
export * from "./_siteCreditsTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports